import React from 'react';
import { B, Arr, Lbl, Lane } from '../shared/SvgHelpers';

export default function DiagramKIDetail() {
  return (
    <div className="space-y-3" data-testid="diagram-ki-detail">
      <h4 className="text-sm font-bold text-purple-700">4. KI-Architektur — 20 Prompts in 7 Anwendungsgruppen</h4>
      <p className="text-xs text-slate-500">Alle KI-Funktionen liefern Vorschläge — Entscheidungen trifft der Bearbeiter.</p>
      <svg viewBox="0 0 780 500" className="w-full rounded-lg border border-slate-200" style={{ background: '#fafbfc' }}>
        <Lane x={5} y={5} w={770} h={115} title="GRUPPE 1: Reklamations-Analyse (P01-P06)" color="#7c3aed" />
        <Lane x={5} y={130} w={380} h={75} title="GRUPPE 2: Beschreibungs-Hilfe (P07)" color="#2563eb" />
        <Lane x={395} y={130} w={380} h={75} title="GRUPPE 3: E-Mail-KI (P09-P12)" color="#0891b2" />
        <Lane x={5} y={215} w={380} h={80} title="GRUPPE 4: Analytics-KI (P13-P15)" color="#4f46e5" />
        <Lane x={395} y={215} w={380} h={80} title="GRUPPE 5: D-Schritt-KI (P16-P17)" color="#16a34a" />
        <Lane x={5} y={305} w={380} h={80} title="GRUPPE 6: Q2-Supplier-KI (P18-P20)" color="#d97706" />
        <Lane x={395} y={305} w={380} h={80} title="GRUPPE 7: Kosten-KI (P21)" color="#e11d48" />
        <Lane x={5} y={395} w={770} h={95} title="MAßNAHMEN-TYPEN (Output von P03) — 4 SMART-Kategorien" color="#16a34a" />

        {/* Gruppe 1 */}
        {[
          { id: 'P01', n: 'Quality-Score\n0-100 Ampel', x: 15 },
          { id: 'P02', n: 'Fehlercode\nmax. 3', x: 135 },
          { id: 'P03', n: 'Maßnahmen\n4 Typen SMART', x: 255 },
          { id: 'P04', n: 'Ursachen 6M\n4-8 Causes', x: 395 },
          { id: 'P05', n: 'Vollanalyse\nD2→D7', x: 525 },
          { id: 'P06', n: '5-Why\n5 Runden', x: 645 },
        ].map((p, i) => (
          <B key={i} x={p.x} y={52} w={110} h={58} label={p.n} color="#7c3aed" sub={p.id} />
        ))}

        {/* Gruppe 2 */}
        <B x={30} y={155} w={160} h={38} label={"KI-Kurzbeschreibung"} color="#2563eb" sub="P07 — generate-short-description" />

        {/* Gruppe 3 */}
        <B x={410} y={155} w={85} h={38} label={"Extraktion"} color="#0891b2" sub="P09" />
        <B x={500} y={155} w={85} h={38} label={"Antwort"} color="#0891b2" sub="P10" />
        <B x={590} y={155} w={85} h={38} label={"Merge"} color="#0891b2" sub="P11" />
        <B x={680} y={155} w={85} h={38} label={"Validierung"} color="#0891b2" sub="P12" />

        {/* Gruppe 4 */}
        <B x={20} y={240} w={115} h={42} label={"Forecast\n(Volumen)"} color="#4f46e5" sub="P13" />
        <B x={140} y={240} w={115} h={42} label={"Risiko-Score\npro Kunde"} color="#4f46e5" sub="P14" />
        <B x={260} y={240} w={115} h={42} label={"Muster-\nErkennung"} color="#4f46e5" sub="P15" />

        {/* Gruppe 5 */}
        <B x={410} y={240} w={175} h={42} label={"D6-Wirksamkeitsprüfung"} color="#16a34a" sub="P16 · suggest-d6-verification" />
        <B x={590} y={240} w={180} h={42} label={"Ishikawa-Diagramm"} color="#16a34a" sub="P17 · suggest-ishikawa" />

        {/* Gruppe 6 */}
        <B x={20} y={330} w={115} h={42} label={"Lieferant\nerkennen"} color="#d97706" sub="P18" />
        <B x={140} y={330} w={115} h={42} label={"Report\nbewerten"} color="#d97706" sub="P19 · 0-100" />
        <B x={260} y={330} w={115} h={42} label={"Lieferanten-\nbrief (DE/EN)"} color="#d97706" sub="P20" />

        {/* Gruppe 7 */}
        <B x={410} y={330} w={360} h={42} label={"Kostenberechnung — 7 Kostenarten + Begründung"} color="#e11d48" sub="P21 · CoPQ · Material · Lohn · Transport · Prüfung · Entsorgung · Ausfall" />

        {/* Maßnahmen 4 Typen */}
        <B x={20} y={420} w={175} h={58} label={"D3 Sofortmaßnahme"} color="#dc2626" sub="24-72h · SMART · Schadensbegrenzung" />
        <B x={205} y={420} w={175} h={58} label={"D5 Korrekturmaßnahme"} color="#d97706" sub="7-30 Tage · Ursache beheben · Nachweis" />
        <B x={390} y={420} w={175} h={58} label={"D6 Wirksamkeitsmaßnahme"} color="#0891b2" sub="Nach 30 Tagen · messbar · dokumentiert" />
        <B x={575} y={420} w={195} h={58} label={"D7 Vorbeugungsmaßnahme"} color="#16a34a" sub="Prozess/Norm · weltweite Prävention" />

        <Arr x1={310} y1={110} x2={140} y2={420} dashed color="#64748b" />
        <Lbl x={210} y={270} text="P03 erzeugt alle 4 Typen" color="#64748b" size={8} />
      </svg>
    </div>
  );
}
